import z from "zod";

export const editSeedSchema = z.object({
  id: z.number(),
  seed: z.number().int().positive(),
  target: z.enum(["division", "pool"]),
});

export const updatePoolSchema = z.object({
  id: z.number(),
  poolId: z.number(),
  seed: z.number().nullable().optional(),
});

export const promoteFromWaitlistSchema = z.object({
  id: z.number(),
  seed: z.number().nullable(),
  automatic: z.boolean(),
  poolId: z.number().optional().nullable(),
  poolSeed: z.number().optional().nullable(),
  tournamentId: z.number(),
});
